import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { MetricsPage } from './MetricsPage'

export const routes: RouteObject[] = [{ path: '/teloscope/metrics', element: <MetricsPage /> }]

// Вкладка раздела «Телоскоп» (pages/teloscope): заголовок раздела рисует оболочка.
export const nav: NavItem[] = [
  { path: '/teloscope/metrics', label: 'Показатели', icon: 'chart', mobile: null, order: 10, parent: '/teloscope' },
]
